"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Popover_1 = __importDefault(require("@material-ui/core/Popover"));
var List_1 = __importDefault(require("@material-ui/core/List"));
var ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
var ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
var styles_1 = require("@material-ui/core/styles");
var columns_1 = require("../../../context/columns");
var sorting_1 = require("../../../context/sorting");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var palette = _a.palette;
    return ({
        activeItem: {
            color: palette.primary.main,
        },
    });
});
var SortingPopover = function (props) {
    var anchorEl = props.anchorEl, onClose = props.onClose;
    var classes = useStyles();
    var _a = (0, columns_1.useColumnsContext)(), columnsState = _a.columnsState, translate = _a.translate;
    var _b = (0, sorting_1.useSortingContext)(), sortingSettings = _b.sortingSettings, setSortingSettings = _b.setSortingSettings, handlerSorting = _b.handlerSorting;
    var items = (0, react_1.useMemo)(function () { return columnsState
        .filter(function (_a) {
        var isSorting = _a.isSorting;
        return isSorting;
    })
        .reduce(function (acc, _a) {
        var id = _a.id, label = _a.label;
        return __spreadArray(__spreadArray([], acc, true), [
            {
                id: id,
                text: "".concat(label, " (").concat(translate('sorting.ascending', 'Ascending'), ")"),
                sortOrder: 0,
            },
            {
                id: id,
                text: "".concat(label, " (").concat(translate('sorting.descending', 'Descending'), ")"),
                sortOrder: 1,
            },
        ], false);
    }, []); }, [translate, columnsState]);
    var onClick = (0, react_1.useCallback)(function (id, sortOrder) { return function () {
        onClose();
        setSortingSettings({
            sortField: id,
            sortOrder: sortOrder
        });
        handlerSorting(id, sortOrder);
    }; }, [setSortingSettings, handlerSorting, onClose]);
    var isActiveItem = (0, react_1.useCallback)(function (id, sortOrder) { return (!!(id === sortingSettings.sortField && sortOrder === sortingSettings.sortOrder)); }, [sortingSettings]);
    return (react_1.default.createElement(Popover_1.default, { open: true, anchorEl: anchorEl, onClose: onClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        } },
        react_1.default.createElement(List_1.default, null, items.map(function (_a) {
            var id = _a.id, text = _a.text, sortOrder = _a.sortOrder;
            return (react_1.default.createElement(ListItem_1.default, { key: id, button: true, onClick: onClick(id, sortOrder) },
                react_1.default.createElement(ListItemText_1.default, __assign({}, (isActiveItem(id, sortOrder) && {
                    classes: { root: classes.activeItem },
                }), { primary: text }))));
        }))));
};
exports.default = SortingPopover;
